/**
 * Composition method for moa overview module
 * 
 * Author: Sahil David
 */
import { computed } from 'vue';
import { getLyraEndpoints } from '@/core/modules/lyra/services';

export function moaDataComposition () {
	// Computed section data
	const sections = computed((): any[] => {
		const moaSections = getLyraEndpoints('moa');
		if (!moaSections) { return []; }

		return moaSections;
	});

	// Computed data
	const datum = computed((): any[] => {
		let returnData: any[] = [];

		const moaFrames = getLyraEndpoints('moa-frames');
		(sections.value || []).forEach((section: any) => {
			let frames: any[] = moaFrames.filter((_: any) => _.moa === section.endpointId);
			frames = frames.sort((a: any, b: any) => parseFloat(a.order) - parseFloat(b.order));

			frames.forEach((obj: any) => {
				obj.section = section.endpointId;
			});
			returnData = returnData.concat(frames);
		});

		return returnData;
	});

	return { sections, datum }
}
